/* ============================================================
   BOTACILS — Motion Engine v2 (GSAP + ScrollTrigger)
   Animations premium, douces, inspirées Nayar / Freckly
   ============================================================ */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll() {
    document.querySelectorAll('.bo-reveal, .bo-clip, [data-words]').forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.clipPath = 'none';
    });
  }

  function initMotion() {
    if (typeof gsap === 'undefined' || reduced) { showAll(); return; }
    gsap.registerPlugin(ScrollTrigger);

    /* 1. Reveal fade + rise (doux, lent) */
    gsap.utils.toArray('.bo-reveal').forEach(function (el) {
      var delay = parseFloat(el.getAttribute('data-delay')) || 0;
      gsap.fromTo(el, { opacity: 0, y: 40 },
        { opacity: 1, y: 0, duration: 1.3, ease: 'power3.out', delay: delay,
          scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
    });

    /* 2. Masque typographique (titres ligne par ligne) */
    gsap.utils.toArray('.bo-mask').forEach(function (mask) {
      var inner = mask.children[0];
      if (!inner) return;
      var delay = parseFloat(mask.getAttribute('data-delay')) || 0;
      gsap.fromTo(inner, { yPercent: 115 },
        { yPercent: 0, duration: 1.3, ease: 'power4.out', delay: delay,
          scrollTrigger: { trigger: mask, start: 'top 92%', once: true } });
    });

    /* 3. Révélation mot par mot [data-words] */
    gsap.utils.toArray('[data-words]').forEach(function (container) {
      var words = container.querySelectorAll('.bo-word');
      var delay = parseFloat(container.getAttribute('data-delay')) || 0;
      gsap.fromTo(words, { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out', stagger: 0.045, delay: delay,
          scrollTrigger: { trigger: container, start: 'top 85%', once: true } });
    });

    /* 4. Clip-reveal images (rideau qui s'ouvre, facon Nayar) */
    gsap.utils.toArray('.bo-clip').forEach(function (el) {
      gsap.fromTo(el, { clipPath: 'inset(0 0 100% 0)' },
        { clipPath: 'inset(0 0 0% 0)', duration: 1.5, ease: 'power3.inOut',
          scrollTrigger: { trigger: el, start: 'top 85%', once: true } });
      var img = el.querySelector('img');
      if (img) {
        gsap.fromTo(img, { scale: 1.25 }, { scale: 1, duration: 1.8, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 85%', once: true } });
      }
    });

    /* 5. Parallaxe [data-parallax] */
    gsap.utils.toArray('[data-parallax]').forEach(function (el) {
      var amount = parseFloat(el.getAttribute('data-parallax')) || 12;
      gsap.to(el, { yPercent: -amount, ease: 'none',
        scrollTrigger: { trigger: el.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1 } });
    });

    /* 6. Lignes qui se tracent [data-line] */
    gsap.utils.toArray('[data-line]').forEach(function (el) {
      gsap.fromTo(el, { scaleX: 0, transformOrigin: 'left center' },
        { scaleX: 1, duration: 1.4, ease: 'power3.inOut',
          scrollTrigger: { trigger: el, start: 'top 92%', once: true } });
    });

    /* 7. Compteurs [data-count] */
    gsap.utils.toArray('[data-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-count'));
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var obj = { v: 0 };
      gsap.to(obj, { v: target, duration: 2, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 90%', once: true },
        onUpdate: function () { el.textContent = obj.v.toFixed(decimals) + (el.getAttribute('data-suffix') || ''); } });
    });

    /* 8. Parallaxe titre hero au scroll */
    var heroTitle = document.querySelector('[data-hero-parallax]');
    if (heroTitle) {
      gsap.to(heroTitle, { yPercent: 24, opacity: 0.3, ease: 'none',
        scrollTrigger: { trigger: heroTitle, start: 'top top', end: 'bottom top', scrub: true } });
    }
  }

  function initHeader() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('header-wrapper--scrolled');
      else header.classList.remove('header-wrapper--scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function boot() { initHeader(); initMotion(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
